import { Container } from 'react-bootstrap'
import img1 from './editie-2023.jpg'
import img2 from './editie-2023-studente.jpg'
import img3 from './editie-2023-recruiter.jpg'
import img4 from './editie-2023-rolmodellen.jpg'
import './Edition2023.scss'

interface edition2023Props {
    lang: String
}

const Edition2023: React.FC<edition2023Props> = (props: edition2023Props) => {
    return (<div className="edition2023">
        <h1>2023</h1>
        <img src={img1} alt="" className='largeimg mx-5' />
        {props.lang === "nl"
            ? <><p className='mx-4 mt-3'>Op 13 juni 2023 vond de eerste editie van het evenement 'Women at the Top' plaats.
                Bij het openingspraatje gegeven door Astrid van Buijssen-van Dongen was de collegezaal gevuld met 100%
                vrouwen. Dit is een unicum voor de Technische Universiteit Eindhoven, waar over het algemeen het
                merendeel van de collegezaal gevuld is met mannen. Geïnspireerd door de wijze woorden van Astrid
                verlieten de 106 studentes de collegezaal om te verplaatsen naar de senaatszaal. Een mooie ruimte, waar
                ironisch gezien nu nog alleen maar foto's van mannen hangen die vroeger de rol van Rector Magnificus
                vervulden. Een mooi voorbeeld van waarom dit evenement wordt georganiseerd. De studentes werden konden
                in 3 verschillende rondes van speeddates telkens verdeeld over de 20 vrouwelijke rolmodellen die
                aanwezig waren. Deze rolmodellen waren afkomstig van wel 12 verschillende bedrijven. Samen vormden zij
                een mooie en hele diverse groep om de huidige studentes te inspireren, ondersteunen en motiveren.
                Benieuwd naar hoe de aanwezige studentes, rolmodellen en campus recruiters het evenement hebben ervaren?
                Lees dan de verhalen hieronder!</p>
                <Container className='row'>
                    <div className="col-md-6">
                        <h2>Het verhaal van een studente</h2>
                        <p >'Zelden heb
                            ik me zo verbonden, gesteund en gemotiveerd
                            gevoeld als na het bijwonen van het "Women at the Top" evenement. In een zaal vol prachtige
                            vrouwen, die ik maar zelden tegenkom in de door mannen gedomineerde collegezalen van de
                            technische wereld, werd ik geïnspireerd door de hartverwarmende verhalen. Vanaf het
                            prikkelende openingspraatje tot het einde bruiste de zaal van frisse energie, vrolijke
                            blikken en enthousiasme. Er werd aandachtig geluisterd naar de twintig rolmodellen, meer dan
                            honderd medestudentes en verschillende vertegenwoordigers. Het geholpen met het maken van
                            keuzes in mijn eigen weg. Deze avond heeft me doen realiseren dat er een krachtige
                            gemeenschap klaarstaat om elkaar te ondersteunen op weg naar succes en persoonlijke groei.
                            De gevoelde saamhorigheid en de waardevolle lessen die ik heb opgedaan, inspireren me om
                            volgend jaar opnieuw deel te nemen. Samen kunnen we de top bereiken.'<br />
                            - Yente van Ginkel, 3de jaars Psychologie & Technologie studente
                        </p>
                    </div>
                    <img src={img2} alt="" className="col-md-6" />
                </Container>
                <Container className='row'>
                    <div className="col-md-6 order-md-last">
                        <h2>Verhalen van rolmodellen</h2>
                        <p>'Dank voor de organisatie van
                            een heel geslaagd event! Super
                            fijne en open sfeer waarin studentes hun vragen konden stellen en twijfels konden delen. Ik
                            hoop dat ik heb kunnenbijdragen door vragen te beantwoorden en mijn ervaringen te
                            delen.'<br />
                            - Judith te Selle, Data Scientist, rolmodel namens Eneco<br /><br /> 'Thanks for organizing such
                            a nice event! We are also very impressed by the organization and the enthousiasm from the
                            students. I couldn't believe it's the first year you're organizing this. I am very happy
                            that we joined the event and had a chance to meet so many students'.<br />
                            - Shuang Xue, Industrial project&programm manager, rolmodel namens NXPSemiconductors</p>
                    </div>
                    <img src={img4} alt="" className='col-md-6' />
                </Container>
                <Container className="row">
                    <div className="col-md-6">
                        <h2>Het verhaal van een recruiter</h2>
                        <p>
                            Afgelopen juni waren was ik samen met een collega aanwezig bij de eerste editie van Vrouwen
                            in de Top. Wat was het inspirerend om zoveel enthousiaste vrouwelijke studenten te
                            ontmoeten! In verschillende rondes mochten we hen vertellen over onze ervaringen als vrouw
                            in een technisch bedrijf en hoe leuk het is om ieder op onze eigen manier vorm te geven aan
                            onze carrière. Door met de studenten in gesprek te gaan, kwamen we erachter waar zij naar op
                            zoek zijn in een baan en wat hun vragen zijn. We hopen dat we met onze ervaringen een
                            bijdrage hebben geleverd en kijken uit naar de volgende editie!<br /> - Anouk Jansen, Campus
                            Recruiter namens Alliander
                        </p>
                    </div>
                    <img src={img3} alt="" className="col-md-6" />
                </Container>
            </>
            : <><p className='mx-4 mt-3'>On June 13, 2023, the first edition of the event 'Women at the Top' took place.
                During the opening speech given by Astrid van Buijssen-van Dongen, the lecture hall was filled with 100%
                women. This is unique for the Eindhoven University of Technology, where generally the majority of the
                lecture hall is filled with men. Inspired by Astrid's wise words, the 106 female students left the
                lecture hall to move to the senate chamber. A beautiful space, where ironically only photos of men who
                used to hold the position of Rector Magnificus hang. A nice example of why this event is organized. The
                students were divided into 3 different rounds of speed dates, each time with the 20 female role models
                present. These role models came from 12 different companies. Together, they formed a beautiful and very
                diverse group to inspire, support, and motivate the current students. Curious about how the present
                students, role models, and campus recruiters experienced the event? Then read the stories on the pages
                indicated below!</p>
                <Container className='row'>
                    <div className="col-md-6">
                        <h2>The story of a student</h2>
                        <p >''Rarely have I felt so connected, supported, and motivated as after attending the "Vrouwen in de
                            top" event. In a room full of beautiful women, whom I rarely encounter in the male-dominated
                            lecture halls of the technical world, I was inspired by the heartwarming stories. From the
                            stimulating opening speech to the end, the room was filled with fresh energy, cheerful looks,
                            and enthusiasm. The twenty role models, more than a hundred fellow students, and various
                            representatives were listened to attentively. Sharing the personal stories, lessons, and
                            challenges of the role models helped me make choices in my own path. This evening made me
                            realize that there is a powerful community ready to support each other on the road to success
                            and personal growth. The felt solidarity and the valuable lessons I have learned inspire me to
                            participate again next year. Together we can reach the top.' <br />
                            - Yente van Ginkel, 3rd year Psychology & Technology student
                        </p>
                    </div>
                    <img src={img2} alt="" className="col-md-6" />
                </Container>
                <Container className='row'>
                    <div className="col-md-6 order-md-last">
                        <h2>Stories of rolemodels</h2>
                        <p>'Thanks for organizing a very successful event! A super nice and open atmosphere in which
                            students could ask their questions and share their doubts. I hope I have been able to contribute
                            by answering questions and sharing my experiences.' <br />
                            - Judith te Selle, Data Scientist, role model on behalf of Eneco <br /><br />
                            questions and sharing my experiences.' - Judith te Selle, Data Scientist, role model on behalf
                            of Eneco 'Thanks for organizing such a nice event! We are also very impressed by the
                            organization and the enthusiasm from the students. I couldn't believe it's the first year you're
                            organizing this. I am very happy that we joined the event and had a chance to meet so many
                            students.' <br />
                            - Shuang Xue, Industrial project&program manager, role model on behalf of NXP Semiconductors</p>
                    </div>
                    <img src={img4} alt="" className='col-md-6' />
                </Container>
                <Container className="row">
                    <div className="col-md-6">
                        <h2>The story of a recruiter</h2>
                        <p>
                            Last June, I was present with a colleague at the first edition of Women at the Top. It was
                            inspiring to meet so many enthusiastic female students! In different rounds, we were able to
                            tell them about our experiences as women in a technical company and how much fun it is to shape
                            our careers in our own way. By talking to the students, we found out what they are looking for
                            in a job and what their questions are. We hope that with our experiences, we have made a
                            contribution and look forward to the next edition! <br />
                            - Anouk Jansen, Campus Recruiter on behalf of Alliander
                        </p>
                    </div>
                    <img src={img3} alt="" className="col-md-6" />
                </Container>

            </>

        }
    </div>)
}

export default Edition2023